export default __webpack_public_path__ + "static/media/UX-Illustration.5e79a081.svg";